






















































import { Component, Vue, Prop } from "vue-property-decorator";
import TeamModal from "../../components/TeamModal.vue";
import Button from "../../components/Button.vue";
import debounce from "debounce";
import { Action } from "vuex-class";
import { USER_SEARCH, CREATE_TEAM } from "../../store/actions.names";
import { FlatUser } from "../../store/store.types";
import { namespaced, NS_ADMIN } from "../../store/namespace";
@Component({
  name: "Createteam",
  components: {
    TeamModal,
    Button,
  },
})
export default class CreateTeam extends Vue {
  // Modal Function
  @Prop() readonly show: any;
  showModal: boolean = false;
  selectedUsers = {};
  name = "";
  searchData = {
    searchTerm: "",
    users: [],
  };
  @Action(namespaced(NS_ADMIN, USER_SEARCH)) userSearch: any;
  @Action(namespaced(NS_ADMIN, CREATE_TEAM)) createTeam: any;
  close() {
    this.$emit("close");
  }

  search = debounce((e) => {
    if (e.target.value.length != 0) {
      this.userSearch(e.target.value).then((users) => {
        this.$set(this.searchData, "users", users.results);
        this.$set(this.searchData, "searchTearm", "");
      });
    } else {
      this.$set(this.searchData, "users", []);
    }
  }, 300);

  addUser(user) {
    this.$set(this.selectedUsers, user.id, user);
    (this.$refs.searchInput as HTMLInputElement).value = "";
    this.$set(this.searchData, "users", []);
  }

  deleteUser(key) {
    this.$delete(this.selectedUsers, key);
  }

  closeModal() {
    this.close();
  }

  addTeam() {
    // console.log("creating");
    const data = {
      name: this.name,
      users_id: Object.keys(this.selectedUsers).map((v) => {
        return parseInt(v);
      }),
    };
    this.createTeam(data).then(() => {
      this.closeModal();
    });
  }
}
